/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Tag, Timeline } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import RiskRegisterService from '../../../services/RiskRegister.service';
import { useEffect, useState } from 'react';

export default function HistoryDrawer({ isChangeStatus, setIsChangeStatus }) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { menu } = useParams();

    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const { riskId } = useParams();

    const _getTagStatus = (e) => {
        switch (e?.statusTh) {
            case 'แบบร่าง':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#65707A', borderColor: '#65707A' }}
                    >
                        {i18n.language === 'en' ? e?.statusEn : e?.statusTh}
                    </Tag>
                );
            case 'รอตรวจสอบ':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#F9C153', borderColor: '#F9C153' }}
                    >
                        {i18n.language === 'en' ? e?.statusEn : e?.statusTh}
                    </Tag>
                );
            case 'ตรวจสอบแล้ว':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {i18n.language === 'en' ? e?.statusEn : e?.statusTh}
                    </Tag>
                );
            case 'ส่งคืนแก้ไข':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#F0536F', borderColor: '#F0536F' }}
                    >
                        {i18n.language === 'en' ? e?.statusEn : e?.statusTh}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    const getHistory = async (params) => {
        setLoading(true);
        try {
            setTimeout(async () => {
                const { data } = await RiskRegisterService.getHistories(params);
                if (data?.resultData) {
                    if (params.p === 1) {
                        setHistories(data.resultData?.result);
                        setPage(2);
                    } else {
                        const history = histories.concat(
                            data.resultData?.result
                        );
                        setHistories(history);
                        setPage(page + 1);
                    }
                    setTotal(data?.resultData?.total);
                    setLoading(false);
                }
            }, 300);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (isChangeStatus) {
            const params = {
                riskRegisterId: riskId,
                p: 1,
                ps: 10,
                sd: 'DESC',
            };
            setHistories([]);
            getHistory(params);
            setIsChangeStatus(false);
        }
    }, [isChangeStatus]);

    const scrollEvent = (e) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const threshold = scrollHeight * 0.9; // 90% of the total height
        if (scrollTop >= threshold && total > histories.length && !loading) {
            const params = {
                riskRegisterId: riskId,
                p: page,
                ps: 10,
                sd: 'DESC',
            };
            getHistory(params);
        }
    };

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    onScroll={scrollEvent}
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    {histories?.length > 0 ? (
                        histories?.map((item, i) => (
                            <Timeline.Item
                                key={item?.riskRegisterHistoryId}
                                color={i === 0 ? '#F0536F' : '#3699FF'}
                            >
                                <button
                                    className={classNames(
                                        'bg-[#EDEEF9] p-2 rounded-lg space-y-2 cursor-pointer hover:opacity-90 text-left w-full',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                    onClick={() => {
                                        const path =
                                            menu !== 'ra'
                                                ? `${ROUTER.RISK_MANAGEMENT.RR}`
                                                : `${ROUTER.RISK_MANAGEMENT.RA}/ra/risk-register`;

                                        navigate(
                                            `${path}/${item?.riskRegisterHistoryId}/history`
                                        );
                                    }}
                                >
                                    <div className="grid grid-cols-4 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('LogDate')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.logDate
                                                ? moment(item?.logDate).format(
                                                      'DD/MM/YYYY HH:mm'
                                                  )
                                                : '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Update By')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.updateBy || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Version')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.version || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Action')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>
                                                <Tag
                                                    className="rounded-xl -my-1 text-center px-4 text-white"
                                                    color="#7B67FB"
                                                >
                                                    {i18n.language === 'en'
                                                        ? item?.actionEn
                                                        : item?.actionTh}
                                                </Tag>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Status')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>{_getTagStatus(item)}</span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Comment')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item.comment || '-'}
                                        </div>
                                    </div>
                                </button>
                            </Timeline.Item>
                        ))
                    ) : (
                        <div className="h-[30vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
        </Timeline>
    );
}
